import { getHostName } from "../utils";

export async function fetchOrbits() {
  const data = await fetch(`${getHostName()}/api/orbit/?format=json`);
  return await data.json();
}
